import { render, staticRenderFns } from "./OverviewModal.vue?vue&type=template&id=41d80d81&"
import script from "./OverviewModal.vue?vue&type=script&lang=js&"
export * from "./OverviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d80d81')) {
      api.createRecord('41d80d81', component.options)
    } else {
      api.reload('41d80d81', component.options)
    }
    module.hot.accept("./OverviewModal.vue?vue&type=template&id=41d80d81&", function () {
      api.rerender('41d80d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/OverviewModal.vue"
export default component.exports